import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Audio } from '@tencent/spaui-business';
import Dialog from '@/components/Dialog';
import className from 'classnames';
import { connect } from 'react-redux';
import perms from '@/common/permissions/sale/perms';
import './style.scoped.less';
import DateTime from '@/components/DateTime';

class AudioBar extends PureComponent {
  static propTypes = {
    url: PropTypes.string.isRequired,
    onClose: PropTypes.func,
  }

  componentDidMount() {
    this.renderDownloadBtn();
  }

  renderDownloadBtn = () => {
    const audio = document.querySelector('.audio-modal .spaui-audio-toolbar .spaui-audio-play-wrap .spaui-audio-play-pause');
    const download = document.createElement('span');
    download.className = 'record-download';
    audio && audio.appendChild(download);
    download.addEventListener('click', (e) => {
      e.stopPropagation();
      this.download();
    });
  }

  download = () => {
    const { url } = this.props;
    window.open(`${url}&response-content-disposition=attachment`);
  }

  render() {
    const { url, startTime, employeeId, employeeName, displayNumber, leadId, customerNumber, seatNo, callSessionId, loginStatus } = this.props;
    const purview = loginStatus.oneOf([perms.REPORT_RECORDING_DOWNLOAD]); // 下载权限
    return (
      <Dialog className="getRecord" title="录音播放" {...this.props} style={{ width: 780 }} submitButton={false} cancelButton={false}>
        <div className='record-info'>
          <dl>
            <dt>时间</dt>
            <dd style={{ width: '25%' }}>
              {
                startTime ? <DateTime dateTime={startTime} /> : null
              }
            </dd>
            <dt>关联线索ID</dt>
            <dd>{ leadId || '' }</dd>
            <dt>总机号码</dt>
            <dd style={{ width: '25%' }}>{`${displayNumber ? displayNumber + '(呼出)' : ''}`}</dd>
            <dt>跟进销售</dt>
            <dd>{`${employeeName ? employeeName + '(' + employeeId + ')' : ''}`}</dd>
            <dt>客户号码</dt>
            <dd style={{ width: '25%' }}>{ customerNumber || '' }</dd>
            <dt>坐席工号</dt>
            <dd>{ seatNo || '' }</dd>
            <dt>录音编号</dt>
            <dd style={{ width: '25%' }}>{ callSessionId || '' }</dd>
          </dl>
        </div>
        <Audio data={url} clear={true} audioProps={{ autoPlay: "autoplay" }} className={className({ "audio-modal": purview })} />
        <span className="record-download"></span>
      </Dialog>
    );
  }
}

function mapStateToProps(state) {
  return {
    loginStatus: state.loginStatus,
  };
}

export default connect(mapStateToProps, {})(AudioBar);
